export default __webpack_public_path__ + "static/banner_web_app-685392ecce89508ba7699e964c6b2567.webp";